import { useState,useEffect } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, } from "firebase/firestore";
import { collection, getDocs, getDoc, doc, onSnapshot, setDoc} from "firebase/firestore";
import CelebrityRow from "./celebrityRow";
import AddNewCeleb from "./addNewCeleb";
import {FaPen, FaPlus} from "react-icons/fa";
import swal from "sweetalert";
import {AiOutlineDelete} from "react-icons/ai";

const db = getFirestore();



export default function FrontPageCategories(){

    const [categories,setCategories] = useState([{"name":"Loading","celebrities":[]}]);
    const [currentCategory,setCurrentCategory] = useState(0);
    const [currentCategoryName,setCurrentCategoryName]=useState(0);


    const listenForData = async() => {

        const unsubscribe= await onSnapshot(doc(db, "appSettings", "categories"), (doc) => {
            var newCats= doc.data()["categories"];
            console.log(newCats);
            setCategories([...newCats]);
            console.log("updated");
        });

    };


    useEffect(async()=>{
        console.log('Loading Page')
        listenForData();
        console.log("Loaded Page One Time");
    },[currentCategory]);



    return(
        <div className="bg-white/10 h-96 w-full flex flex-row rounded-md">

            <div className="flex flex-col bg-transparent h-full w-1/4">
                
                <div className="flex-4 h-full w-full overflow-scroll pb-10">
                    {
                        categories.map((e,index)=>{
                            return(
                            <button
                                onClick={()=>{
                                    setCurrentCategory(index);
                                }}
                                key={index}
                                    className="hover:bg-blue-900 hover:text-white hover:bg-blue-500 text-sm w-full rounded-sm bg-white p-2 mt-2 mb-2 text-black font-normal text-left flex justify-start items-center flex-row justify-between">
                                <div className="overflow-hidden">{e["name"]}</div>

                            </button>
                            )
                        })
                    }
                </div>
                
                <div className="flex-1 h-96 flex justify-center items-end text-black">
                    <button 
                    onClick={
                    ()=>{
                        let temp=categories;
                        temp.push({"name":"testing","celebrities":[]});
                        const ref = doc(db, 'appSettings', 'categories');
                        setDoc(ref, { categories: temp }, { merge: true });
                        console.log(temp);
                        }
                    } 
                    className="hover:scale-105 bg-yellow-400 h-12 w-full font-bold flex justify-center items-center">
                        <FaPlus  size={20}/>
                    </button>
                </div>
                
            
            </div>


            {
                categories.length!==0 && categories[currentCategory]!=null?
                    <div className="flex flex-row w-full">

                        <div className="h-full w-3/4 flex justify-start items-start p-5 flex-col overflow-scroll">

                            <div className="text-4xl font-bold mb-5 flex flex-row">
                                <div>{ categories[currentCategory]["name"] }</div>

                                <button
                                    onClick={()=>{

                                        swal("Kindly Enter New Name for the Category", {
                                            content: "input",
                                        }).then(async(value) => {
                                                if(value.trim()!=""){
                                                    let data= (await getDoc(doc(db, "appSettings", "categories"))).data();
                                                    data["categories"][currentCategory]["name"]=value;
                                                    setDoc(doc(db,"appSettings","categories"),data,{merge:true});
                                                }
                                                else{
                                                    swal(`You Entered an empty value`   );
                                                }
                                        });

                                    }}
                                    className="hover:scale-105 hover:bg-red-500 text-sm bg-white/50 p-2 rounded ml-5 flex justify-center items-center">
                                    <FaPen size={24}/>
                                </button>


                                <button
                                    onClick={async()=>{


                                        const willDelete = await swal({
                                            title: "Are you sure?",
                                            text: "Are you sure that you want to delete this category?",
                                            icon: "warning",
                                            dangerMode: true,

                                        });

                                        if (willDelete) {
                                            let data= (await getDoc(doc(db, "appSettings", "categories"))).data();
                                            data["categories"].splice(currentCategory,1);
                                            setDoc(doc(db,"appSettings","categories"),data,{merge:true});

                                            swal("Deleted!", "The Category Was deleted!", "success");
                                        }
                                        else{
                                        }


                                    }}
                                    className="hover:scale-105 hover:bg-red-500 text-sm bg-white/50 p-2 rounded ml-3 flex justify-center items-center">
                                    <AiOutlineDelete size={24}/>
                                </button>



                            </div>

                            {
                                categories[currentCategory]["celebrities"].map((e,celebrityIndex)=>{
                                    return(
                                        <CelebrityRow key={`${currentCategory}${celebrityIndex}`} category={categories[currentCategory]["name"]} categoryIndex={currentCategory} celebrityIndex={celebrityIndex} id={e} />
                                    )
                                })
                            }

                        </div>
                        <div className="h-full w-1/4 flex flex-col justify-center items-center">
                            <AddNewCeleb category={categories[currentCategory]["name"]} categoryIndex={currentCategory}  />
                        </div>
                    </div>
                    :
                <div></div>

            }




        </div>
    )
}